
import { Component, Prop, Vue } from "nuxt-property-decorator";

@Component({})
export default class EsyH4 extends Vue {
  @Prop({ default: "default" }) variant: string;
}
